import type { NetworkId, NetworkInfo } from "@alch/dx-entities";
import type { ComposerCategory } from "./categories.js";
import type { ComposerParam } from "./params.js";

export interface ComposerMethodConfig {
  name: string;
  category?: ComposerCategory;
  docsUrl?: string;
  networks: NetworkId[];
  httpMethod: string;
  url: string;
  queryParams?: ComposerParam[];
  requestBody?: ComposerParam;
}

export const filterMethodNetworkInfos = (
  methodConfigs: ComposerMethodConfig[],
  networkInfos: NetworkInfo[],
) => {
  return networkInfos.filter((network) =>
    methodConfigs.some((method) => method.networks.includes(network.id)),
  );
};

export const filterCategoriesMethodConfigs = (
  methodConfigs: ComposerMethodConfig[],
  categories: ComposerCategory[],
) => {
  if (categories.length === 0) {
    return methodConfigs;
  }

  return methodConfigs.filter(
    (method) => method.category && categories.includes(method.category),
  );
};

export const getMethodConfigsByName = (
  methodConfigs: ComposerMethodConfig[],
  methodName: string,
) => {
  return methodConfigs.filter((method) => method.name === methodName);
};

export const getUniqueMethodConfig = (
  methodConfigs: ComposerMethodConfig[],
  filter: { method: string; network: NetworkId | undefined },
) => {
  return methodConfigs.find(
    (config) =>
      config.name === filter.method &&
      (filter.network == null
        ? config.networks.length === 0
        : config.networks.includes(filter.network)),
  );
};
